import React, { useState, useCallback } from 'react'
import { useTimer } from '../../hooks/useTimer'
import { useTimerNotifications } from '../../hooks/useTimerNotifications'
import TimerCard from './TimerCard'
import TimerFullScreen from './TimerFullScreen'
import StopModal from './StopModal'
import CloseTimerModal from './CloseTimerModal'

/**
 * Componente principal do Timer
 * Gerencia a exibição entre modo card e fullscreen
 * Controla a abertura dos modais (parar e fechar)
 * Gerencia notificações quando tempo expira
 */
const Timer: React.FC = () => {
  const { mode, isVisible, status, timeRemaining, currentSession } = useTimer()
  const [isStopModalOpen, setIsStopModalOpen] = useState(false)
  const [isCloseModalOpen, setIsCloseModalOpen] = useState(false)

  // Handler quando tempo expira - abre modal automaticamente
  const handleTimeExpired = useCallback(() => {
    setIsStopModalOpen(true)
  }, [])

  // Hook de notificações
  useTimerNotifications({
    timeRemaining,
    status,
    currentSubject: currentSession?.subject || null,
    onTimeExpired: handleTimeExpired,
  })

  // Não renderiza nada se não estiver visível
  if (!isVisible) {
    return null
  }

  const handleStopClick = () => {
    setIsStopModalOpen(true)
  }

  const handleCloseStopModal = () => {
    setIsStopModalOpen(false)
  }

  const handleCloseClick = () => {
    setIsCloseModalOpen(true)
  }

  const handleCloseCloseModal = () => {
    setIsCloseModalOpen(false)
  }

  return (
    <>
      {mode === 'card' && (
        <TimerCard onStopClick={handleStopClick} onCloseClick={handleCloseClick} />
      )}

      {mode === 'fullscreen' && (
        <TimerFullScreen onStopClick={handleStopClick} onCloseClick={handleCloseClick} />
      )}

      <StopModal isOpen={isStopModalOpen} onClose={handleCloseStopModal} />

      <CloseTimerModal isOpen={isCloseModalOpen} onClose={handleCloseCloseModal} />
    </>
  )
}

export default Timer
